import { useMemo } from 'react'
import ResponsibleUsers from './ResponsibleUsers/ResponsibleUsers'
import { Banner } from '../../../components/Banner/Banner'
import { EditContractCategory } from './EditContractCategory/EditContractCategory'
import { AdditionalInfo } from './ViewContractCategory/AdditionalInfo'
import { ViewContractCategory } from './ViewContractCategory/ViewContractCategory'
import { useContractCategoryDetailsContext } from '../Providers/ContractCategoryDetailsContextProvider'
import { defaultDateFormat } from '../../../helper/dates'
import { ContractCategoryStatus } from '../../Categories/types'
import './styles.scss'

export const General = () => {
  const { canEditContractCategory, isNewContractCategory, details } =
    useContractCategoryDetailsContext().state

  const ContractCategoryDetails = useMemo(
    () =>
      canEditContractCategory || isNewContractCategory ? (
        <EditContractCategory isNew={isNewContractCategory} />
      ) : (
        <ViewContractCategory />
      ),
    [canEditContractCategory, isNewContractCategory]
  )
  return (
    <>
      {details.status === ContractCategoryStatus.EXPIRED && (
        <Banner.Warning
          className="mb-24"
          text={`All category's contracts expired on ${defaultDateFormat(
            details.latest_contract_finish_date
          )}`}
        />
      )}
      {details.status === ContractCategoryStatus.INACTIVE && (
        <Banner.Warning
          className="mb-24"
          text={`All category's contracts terminated/declined on ${defaultDateFormat(
            details.latest_contract_inactive_date
          )}`}
        />
      )}
      <div className="contract-category-details-general">
        <div className="contract-category-details-general__details row gap-24">
          {ContractCategoryDetails}
          {!isNewContractCategory && <AdditionalInfo />}
        </div>
        {!isNewContractCategory && (
          <div className="contract-category-details-general__responsible">
            <ResponsibleUsers />
          </div>
        )}
      </div>
    </>
  )
}
